import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend'
import { Card } from './Card';
import { DnDItemTypes } from '../basic/Utilities';
import {FormattedMessage} from "react-intl";
import { Cards, CARDSPATH, CARDBACK } from "../assets/gameData";

const getImgSrc = (open, cardImg, cardBack) => {
    return open ? CARDSPATH + cardImg : cardBack
};

export const getCardImgData = (id) => {
    return Cards.filter((item) => item.id === id)[0];
};

export const DraggableCard = ({id, isActive, open, left, top, zIndex, itemKey, allowedActions, selected, onZoom, onToggleActive, onToggleSide}) => {
    const cardData = getCardImgData(id);

    const [{ isDragging }, drag, preview] = useDrag({
        item: {
            id,
            left,
            top,
            img: getImgSrc(open, cardData.img, CARDBACK),
            open: open,
            type: DnDItemTypes.CARD,
            selected,
            itemKey
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        /*begin: (monitor) => (
            console.log("begin", monitor)
        ),
        end: (item, monitor) => (
            console.log(monitor, item)
        ),*/
    });

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, [preview]);

    let classes = "gm-card";
    classes += open ? " open " : " closed ";
    classes += isActive ? " active " : "";
    classes += isDragging ? " dragging " : "";

    if(cardData){
        return (
            <div className={classes} ref={left !== 'auto' ? drag : undefined} style={{top, left, zIndex} } onClick={() => {onToggleActive(itemKey); !open && onToggleSide(itemKey)}}>
                <Card src={getImgSrc(open, cardData.img, CARDBACK)} alt={cardData.id} />
                {open && !isDragging && (
                    <div className="img-actions">
                        <span className="number">{id}</span>
                        {isActive && allowedActions && (
                            <div className="buttons">
                                {allowedActions.turn &&
                                <button className="btn btn-link text-white icon-hide-white" onClick={() => {onToggleSide(itemKey); onToggleActive(itemKey) }}>
                                    <span className="sr-only"><FormattedMessage id="card.turn.btn" /></span>
                                </button>
                                }
                                {allowedActions.zoom &&
                                <button className="btn btn-link text-white icon-zoom-in" onClick={() => {onZoom(id)}}>
                                    <span className="sr-only"><FormattedMessage id="card.zoom.btn" /></span>
                                </button>
                                }
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    } else {
        return false;
    }
};